import React from 'react'
import Testimonials from '../Components/Testimonials'
const CustomerTestimonials = () => {
  return (
    <div className='pt-32'>
      <Testimonials/>
    </div>
  )
}

export default CustomerTestimonials
